import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getS3Media, updateUserFormsDetails } from "../../services/awsServices";
import { getUserAllFormsDetails } from "../../slices/userSlice";
import { TrashIcon } from "../../utils/icons";
import toastMessage from "../../utils/toastMessage";
import { uploadDocFun } from "../../utils/utils";
import PersonalityAttributesModal from "./PersonalityAttributesModal";
import NotificationPopover from "../NotificationPopover";
import { Tooltip } from "antd";

const PersonalityAttributes = ({ notifications }) => {
  const {
    SoftSkillsNotification,
    SpecialTalentNotification,
    PsychologicalChallengeNotification,
    SocialChallengesNotification,
    ActivityDataNotification,
    LanguageDataNotification,
    WebsiteDataNotification,
  } = notifications;
  const dispatch = useDispatch();
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [attribute, setAttribute] = useState({});
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const personalAtt = [
    {
      id: 1,
      name: (
        <div className="flex justify-between">
          <p className="mr-2">Soft Skills</p>
          <NotificationPopover notifications={SoftSkillsNotification} />
        </div>
      ),
      _for: "SoftSkills",
    },
    {
      id: 2,
      name: (
        <div className="flex justify-between">
          <p className="mr-2">Special Talent</p>
          <NotificationPopover notifications={SpecialTalentNotification} />
        </div>
      ),
      _for: "SpecialTalent",
    },
    {
      id: 3,
      name: (
        <div className="flex justify-between">
          <p className="mr-2">Psychological Challenges</p>
          <NotificationPopover
            notifications={PsychologicalChallengeNotification}
          />
        </div>
      ),
      _for: "PsychologicalChallenges",
    },
    {
      id: 4,
      name: (
        <div className="flex justify-between">
          <p className="mr-2">Social Challenges</p>
          <NotificationPopover notifications={SocialChallengesNotification} />
        </div>
      ),
      _for: "SocialChallenges",
    },
    {
      id: 5,
      name: (
        <div className="flex justify-between">
          <p className="mr-2">Extra Curricular Activities</p>
          <NotificationPopover notifications={ActivityDataNotification} />
        </div>
      ),
      _for: "ExtraCurricularActivities",
    },
    {
      id: 6,
      name: (
        <div className="flex justify-between">
          <p className="mr-2">Add Languages</p>
          <NotificationPopover notifications={LanguageDataNotification} />
        </div>
      ),
      _for: "AddLanguages",
    },
    {
      id: 7,
      name: (
        <div className="flex justify-between">
          <p className="mr-2">Add Website</p>
          <NotificationPopover notifications={WebsiteDataNotification} />
        </div>
      ),
      _for: "AddWebsite",
    },
  ];

  async function getUrls(values) {
    if (values?.length > 0 && Array.isArray(values)) {
      const data = [];
      for (let i = 0; i < values?.length; i++) {
        const element = values[i];
        if (element?.length === 0) continue;
        if (element.includes("https://m3demobucketone.s3")) {
          data.push(element);
        } else {
          const res = await getS3Media(element);
          data.push(res?.data?.url);
        }
      }
      return data;
    } else if (values && values?.length > 0) {
      const res = await getS3Media(values);
      return [res?.data?.url];
    } else return [];
  }

  const getDataWithAttachment = async (arr) => {
    console.log(arr, "===attttributessssssssssss:dataAttachment");
    const data = [];
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i];
      if (element?.Attachments?.length === 0) {
        data.push({ ...element, Attachments: [] });
        continue;
      }
      const Attachments = await getUrls(element?.Attachments);
      data.push({ ...element, Attachments });
    }
    return data;
  };

  async function getDataInFormat() {
    const attribute = {
      AddLanguages: [],
      SoftSkills: [],
      SpecialTalent: [],
      PsychologicalChallenges: [],
      SocialChallenges: [],
      ExtraCurricularActivities: [],
      AddWebsite: [],
    };
    for (let i = 0; i < userAllFormsDetails?.length; i++) {
      const data = userAllFormsDetails[i];
      if (data.SK === "Skills#Soft") {
        attribute["SoftSkills"] = data.Data;
      } else if (data.SK === "SpecialTalent#") {
        attribute["SpecialTalent"] = data.Data;
      } else if (data.SK === "Talent#Challenges#Psychological") {
        attribute["PsychologicalChallenges"] = data.Data;
      } else if (data.SK === "Talent#Challenges#Social") {
        attribute["SocialChallenges"] = data.Data;
      } else if (data.SK === "Activity#ExtraCurricular") {
        attribute["ExtraCurricularActivities"] = data.Data;
      } else if (data.SK === "Add#Languages") {
        attribute["AddLanguages"] = data.Data;
      } else if (data.SK === "Add#Website") {
        attribute["AddWebsite"] = data.Data;
      }
    }

    console.log(attribute, " ====attribute:useEff");
    setAttribute(attribute);
  }

  useEffect(() => {
    getDataInFormat();
  }, [userAllFormsDetails]);

  const slideValueCalc = (value) => {
    console.log("🚀 ~ slideValueCalc ~ value:", value);
    switch (value) {
      case 25:
        return "Novice";
      case 50:
        return "Average";
      case 75:
        return "Expert";
      case 100:
        return "Superior";
      default:
        return "";
    }
  };

  const handleSave = async (values) => {
    console.log(typeof values.Slide, "==valueeessssss, ", modal, " = for");
    setLoading(true);
    try {
      if (modal === "SoftSkills") {
        let fileName = "";
        if (values.File?.length) {
          fileName = await uploadDocFun(values.File);
        }
        console.log(fileName, "==fileName", attribute[modal]);
        const newData = [
          ...attribute[modal],
          {
            Name: values?.Name || "",
            Description: values?.Description || "",
            Attachments: [fileName],
            Slide: slideValueCalc(values?.Slide) || "",
          },
        ];
        setAttribute((prev) => ({ ...prev, SoftSkills: newData }));
        const res = await updateUserFormsDetails({
          Data: newData,
          SK: "Skills#Soft",
        });
        toastMessage("Data has been added", "success");
        setLoading(false);
      } else if (modal === "SpecialTalent") {
        let fileName = "";
        if (values.File?.length) {
          fileName = await uploadDocFun(values.File);
        }
        const newData = [
          ...attribute[modal],
          {
            Name: values?.Name || "",
            Description: values?.Description || "",
            Attachments: [fileName],
            Slide: slideValueCalc(values?.Slide) || "",
          },
        ];
        setAttribute((prev) => ({ ...prev, SpecialTalent: newData }));
        const res = await updateUserFormsDetails({
          Data: newData,
          SK: "SpecialTalent#",
        });
        toastMessage("Data has been added", "success");
        setLoading(false);
      } else if (modal === "ExtraCurricularActivities") {
        let fileName = "";
        if (values.File?.length) {
          fileName = await uploadDocFun(values.File);
        }
        const newData = [
          ...attribute[modal],
          {
            Name: values?.Name || "",
            Description: values?.Description || "",
            Attachments: [fileName],
            Slide: slideValueCalc(values?.Slide) || "",
          },
        ];
        setAttribute((prev) => ({
          ...prev,
          ExtraCurricularActivities: newData,
        }));
        const res = await updateUserFormsDetails({
          Data: newData,
          SK: "Activity#ExtraCurricular",
        });
        toastMessage("Data has been added", "success");
        setLoading(false);
      } else if (modal === "PsychologicalChallenges") {
        let fileName = "";
        if (values.File?.length) {
          fileName = await uploadDocFun(values.File);
        }
        const newData = [
          ...attribute[modal],
          {
            Name: values?.Name || "",
            Description: values?.Description || "",
            Attachments: [fileName],
            Slide: slideValueCalc(values?.Slide) || "",
          },
        ];
        setAttribute((prev) => ({ ...prev, PsychologicalChallenges: newData }));
        const res = await updateUserFormsDetails({
          Data: newData,
          SK: "Talent#Challenges#Psychological",
        });
        toastMessage("Data has been added", "success");
        setLoading(false);
      } else if (modal === "SocialChallenges") {
        let fileName = "";
        if (values.File?.length) {
          fileName = await uploadDocFun(values.File);
        }
        const newData = [
          ...attribute[modal],
          {
            Name: values?.Name || "",
            Description: values?.Description || "",
            Attachments: [fileName],
            Slide: slideValueCalc(values?.Slide) || "",
          },
        ];
        setAttribute((prev) => ({ ...prev, SocialChallenges: newData }));
        const res = await updateUserFormsDetails({
          Data: newData,
          SK: "Talent#Challenges#Social",
        });
        toastMessage("Data has been added", "success");
        setLoading(false);
      } else if (modal === "AddLanguages") {
        // let fileName = "";
        // if (values.File?.length) {
        //   fileName = await uploadDocFun(values.File);
        // }
        const newData = [
          ...attribute[modal],
          {
            Language: values?.SpecifyLanguage || "",
            Proficiency: values?.LanguageProficiency || "",
            // Attachments: [fileName],
            // Slide: slideValueCalc(values?.Slide) || "",
          },
        ];
        console.log(newData, "data:addlang");
        setAttribute((prev) => ({ ...prev, AddLanguages: newData }));
        const res = await updateUserFormsDetails({
          Data: newData,
          SK: "Add#Languages",
        });
        toastMessage("Data has been added", "success");
        setLoading(false);
      } else if (modal === "AddWebsite") {
        // let fileName = "";
        // if (values.File?.length) {
        //   fileName = await uploadDocFun(values.File);
        // }
        const newData = [
          ...attribute[modal],
          {
            "Website URL": values?.SpecifyWebsiteURL || "",
            Description: values?.specifyTypeOfWebsite || "",
            // Attachments: [fileName],
            // Slide: slideValueCalc(values?.Slide) || "",
          },
        ];
        console.log(newData, "data:addlang");
        setAttribute((prev) => ({ ...prev, AddWebsite: newData }));
        const res = await updateUserFormsDetails({
          Data: newData,
          SK: "Add#Website",
        });
        toastMessage("Data has been added", "success");
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "errooorrrrrrrrrrrrrrrrrr");
      toastMessage("Can't Add or update at this time", "error");
      setLoading(false);
    }
    setModal(null);
    dispatch(getUserAllFormsDetails()).unwrap();
  };

  const handleDelete = async (_for, rem) => {
    if (_for === "SoftSkills") {
      const updatedData = [];
      for (let i = 0; i < attribute[_for]?.length; i++) {
        if (i === rem) continue;
        updatedData.push(attribute[_for][i]);
      }
      console.log(updatedData, "===updatedData:handleDelete");
      setAttribute((prev) => ({ ...prev, SoftSkills: updatedData }));
      const res = await updateUserFormsDetails({
        Data: updatedData,
        SK: "Skills#Soft",
      });
      toastMessage("Successfully Deleted", "success");
      dispatch(getUserAllFormsDetails()).unwrap();
    }
    if (_for === "SpecialTalent") {
      const updatedData = [];
      for (let i = 0; i < attribute[_for]?.length; i++) {
        if (i === rem) continue;
        updatedData.push(attribute[_for][i]);
      }
      console.log(updatedData, "===updatedData:handleDelete");
      setAttribute((prev) => ({ ...prev, SoftSkills: updatedData }));
      const res = await updateUserFormsDetails({
        Data: updatedData,
        SK: "SpecialTalent#",
      });
      toastMessage("Successfully Deleted", "success");
      dispatch(getUserAllFormsDetails()).unwrap();
    }
    if (_for === "PsychologicalChallenges") {
      const updatedData = [];
      for (let i = 0; i < attribute[_for]?.length; i++) {
        if (i === rem) continue;
        updatedData.push(attribute[_for][i]);
      }
      console.log(updatedData, "===updatedData:handleDelete");
      setAttribute((prev) => ({ ...prev, SoftSkills: updatedData }));
      const res = await updateUserFormsDetails({
        Data: updatedData,
        SK: "Talent#Challenges#Psychological",
      });
      toastMessage("Successfully Deleted", "success");
      dispatch(getUserAllFormsDetails()).unwrap();
    }
    if (_for === "SocialChallenges") {
      const updatedData = [];
      for (let i = 0; i < attribute[_for]?.length; i++) {
        if (i === rem) continue;
        updatedData.push(attribute[_for][i]);
      }
      console.log(updatedData, "===updatedData:handleDelete");
      setAttribute((prev) => ({ ...prev, SoftSkills: updatedData }));
      const res = await updateUserFormsDetails({
        Data: updatedData,
        SK: "Talent#Challenges#Social",
      });
      toastMessage("Successfully Deleted", "success");
      dispatch(getUserAllFormsDetails()).unwrap();
    }
    if (_for === "ExtraCurricularActivities") {
      const updatedData = [];
      for (let i = 0; i < attribute[_for]?.length; i++) {
        if (i === rem) continue;
        updatedData.push(attribute[_for][i]);
      }
      console.log(updatedData, "===updatedData:handleDelete");
      setAttribute((prev) => ({ ...prev, SoftSkills: updatedData }));
      const res = await updateUserFormsDetails({
        Data: updatedData,
        SK: "Activity#ExtraCurricular",
      });
      toastMessage("Successfully Deleted", "success");
      dispatch(getUserAllFormsDetails()).unwrap();
    }
    if (_for === "AddLanguages") {
      const updatedData = [];
      for (let i = 0; i < attribute[_for]?.length; i++) {
        if (i === rem) continue;
        updatedData.push(attribute[_for][i]);
      }
      console.log(updatedData, "===updatedData:handleDelete");
      setAttribute((prev) => ({ ...prev, SoftSkills: updatedData }));
      const res = await updateUserFormsDetails({
        Data: updatedData,
        SK: "Add#Languages",
      });
      toastMessage("Successfully Deleted", "success");
      dispatch(getUserAllFormsDetails()).unwrap();
    }
    if (_for === "AddWebsite") {
      const updatedData = [];
      for (let i = 0; i < attribute[_for]?.length; i++) {
        if (i === rem) continue;
        updatedData.push(attribute[_for][i]);
      }
      console.log(updatedData, "===updatedData:handleDelete");
      setAttribute((prev) => ({ ...prev, SoftSkills: updatedData }));
      const res = await updateUserFormsDetails({
        Data: updatedData,
        SK: "Add#Website",
      });
      toastMessage("Successfully Deleted", "success");
      dispatch(getUserAllFormsDetails()).unwrap();
    }
  };
  const handleAddMoreClick = (_for) => {
    return function () {
      console.log(_for, " = Add_for");
      setModal(_for);
    };
  };

  return (
    <div>
      <PersonalityAttributesModal
        modal={modal}
        close={() => setModal(null)}
        handleSave={handleSave}
        loading={loading}
      />
      {personalAtt.map((data, i) => (
        <EachAttributeData
          key={i}
          {...data}
          attribute={attribute}
          handleAddMoreClick={handleAddMoreClick}
          handleDelete={handleDelete}
        />
      ))}
    </div>
  );
};

// function EachAttributeData({
//   id,
//   name,
//   _for,
//   attribute,
//   handleAddMoreClick,
//   handleDelete,
// }) {
//   const [toggle, setToggle] = useState(false);
//   const userAllFormsDetails = useSelector(
//     (state) => state.user.userAllFormsDetails
//   );
//   let displayJsx = null;

//   if (toggle && attribute[_for]?.length > 0) {
//     displayJsx = attribute[_for]?.map((data, i) => (
//       <div key={i} className="flex flex-col justify-center items-center">
//         <div className="w-full my-3 p-1">
//           <div className="flex items-center justify-between">
//             <p className="font-bold text-lg">{data.Name}</p>
//             <div
//               className="flex gap-3 cursor-pointer"
//               onClick={() => handleDelete(_for, i)}
//             >
//               {/* <PencilSquareSolid /> */}
//               <TrashIcon className="" color="#FF033E" width="18" height="18" />
//             </div>
//           </div>
//           {data?.Description && (
//             <div className="text-gray-500">{data?.Description}</div>
//           )}
//           {data?.Attachments?.length > 0 && (
//             <div className="text-gray-500">
//               {data?.Attachments?.map((data, i) => (
//                 <a target="_" href={data} key={i}>
//                   {"your-uploaded-file-" + (i + 1)}
//                 </a>
//               ))}
//             </div>
//           )}
//         </div>
//         {attribute[_for]?.length === i + 1 ? (
//           <></>
//         ) : (
//           <div className="h-[0.5px] bg-gray-200 w-full" />
//         )}
//       </div>
//     ));
//   } else if (!attribute[_for] || attribute[_for]?.length === 0) {
//     displayJsx = (
//       <p className="mt-3 text-center text-gray-500">
//         Share your Soft Skills with us!
//       </p>
//     );
//   }

//     console.log(userAllFormsDetails, "=userAllFormsDetailsuserAllFormsDetails:2");

//     const personalAtt = [
//         { id: 1, name: 'Soft Skills', _for: 'SoftSkills' },
//         { id: 2, name: 'Special Talent', _for: 'SpecialTalent' },
//         { id: 3, name: 'Psychological Challenges', _for: 'PsychologicalChallenges' },
//         { id: 4, name: 'Social Challenges', _for: 'SocialChallenges' },
//         { id: 5, name: 'Extra Curricular Activities', _for: 'ExtraCurricularActivities' },
//     ]

//     async function getUrls(values){
//         if(values?.length > 0 && Array.isArray(values)){
//           const data = [];
//           for (let i = 0; i < values?.length; i++) {
//             const element = values[i];
//             if(element?.length === 0) continue;
//             if(element.includes("https://m3demobucketone.s3")){
//                 data.push(element);
//             }
//             else{
//                 const res = await getS3Media(element);
//                 data.push(res?.data?.url);
//             }
//           }
//           return data;
//         }
//         else if(values && values?.length > 0){
//           const res = await getS3Media(values);
//           return [res?.data?.url];
//         }
//         else return [];
//     }

//     const getDataWithAttachment = async (arr) => {
//         console.log(arr, "===attttributessssssssssss:dataAttachment");
//         const data = [];
//         for (let i = 0; i < arr.length; i++) {
//             const element = arr[i];
//             if(element?.Attachments?.length === 0) {
//                 data.push({ ...element, Attachments: [] });
//                 continue;
//             };
//             const Attachments = await getUrls(element?.Attachments);
//             data.push({ ...element, Attachments });
//         }
//         return data;
//     }

//     async function getDataInFormat(){
//         const attribute = {};
//         for (let i = 0; i < userAllFormsDetails?.length; i++) {
//             const data = userAllFormsDetails[i];
//             if(data.SK === "Skills#Soft"){
//                 attribute["SoftSkills"] = await getDataWithAttachment(data.Data);
//             }
//             else if(data.SK === "SpecialTalent#"){
//                 attribute["SpecialTalent"] = data.Data;
//             }
//             else if(data.SK === "Talent#Challenges#Psychological"){
//                 attribute["PsychologicalChallenges"] = data.Data;
//             }
//             else if(data.SK === "Talent#Challenges#Social"){
//                 attribute["SocialChallenges"] = data.Data;
//             }
//             else if(data.SK === "Activity#ExtraCurricular"){
//                 attribute["ExtraCurricularActivities"] = data.Data;
//             }
//         }

//         console.log(attribute, " ====attribute:useEff");
//         setAttribute(attribute);
//     }

//     useEffect(()=>{
//         getDataInFormat();
//     }, [userAllFormsDetails])

//     const handleSave = async (values) => {
//         console.log(values, "==valueeessssss, ", modal, " = for");
//         setLoading(true);
//         try {
//             if(modal === "SoftSkills"){
//                 let fileName = '';
//                 if(values.File?.length){
//                     fileName = await uploadDocFun(values.File);
//                 }
//                 console.log(fileName, "==fileName");
//                 const newData = attribute[modal]?.length > 0 ? [
//                     ...attribute[modal],
//                     {
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ]: [{
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ];
//                 setAttribute(prev => ({ ...prev, "SoftSkills": newData }));
//                 const res = await updateUserFormsDetails({ Data: newData, SK: "Skills#Soft" });
//                 toastMessage("Data has been added","success");
//                 setLoading(false);
//             }
//             else if(modal === "SpecialTalent"){
//                 let fileName = '';
//                 if(values.File?.length){
//                     fileName = await uploadDocFun(values.File);
//                 }
//                 const newData = attribute[modal]?.length > 0 ? [
//                     ...attribute[modal],
//                     {
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ]: [{
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ];
//                 setAttribute(prev => ({ ...prev, "SpecialTalent": newData }));
//                 const res = await updateUserFormsDetails({ Data: newData, SK: "SpecialTalent#" });
//                 toastMessage("Data has been added","success");
//                 setLoading(false);
//             }
//             else if(modal === "ExtraCurricularActivities"){
//                 let fileName = '';
//                 if(values.File?.length){
//                     fileName = await uploadDocFun(values.File);
//                 }
//                 const newData = attribute[modal]?.length > 0 ? [
//                     ...attribute[modal],
//                     {
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ]: [{
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ];
//                 setAttribute(prev => ({ ...prev, "ExtraCurricularActivities": newData }));
//                 const res = await updateUserFormsDetails({ Data: newData, SK: "Activity#ExtraCurricular" });
//                 toastMessage("Data has been added","success");
//                 setLoading(false);
//             }
//             else if(modal === "PsychologicalChallenges"){
//                 let fileName = '';
//                 if(values.File?.length){
//                     fileName = await uploadDocFun(values.File);
//                 }
//                 const newData = attribute[modal]?.length > 0 ? [
//                     ...attribute[modal],
//                     {
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ]: [{
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ];
//                 setAttribute(prev => ({ ...prev, "PsychologicalChallenges": newData }));
//                 const res = await updateUserFormsDetails({ Data: newData, SK: "Talent#Challenges#Psychological" });
//                 toastMessage("Data has been added","success");
//                 setLoading(false);
//             }
//             else if(modal === "SocialChallenges"){
//                 let fileName = '';
//                 if(values.File?.length){
//                     fileName = await uploadDocFun(values.File);
//                 }
//                 const newData = attribute[modal]?.length > 0 ? [
//                     ...attribute[modal],
//                     {
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ]: [{
//                         Name: values?.Name || "",
//                         Description: values?.Description || "",
//                         Attachments: [fileName]
//                     },
//                 ];
//                 setAttribute(prev => ({ ...prev, "SocialChallenges": newData }));
//                 const res = await updateUserFormsDetails({ Data: newData, SK: "Talent#Challenges#Social" });
//                 toastMessage("Data has been added","success");
//                 setLoading(false);
//             }
//         } catch (error) {
//             toastMessage("Can't Add or update at this time","error");
//             setLoading(false);
//         }
//         setModal(null);
//         dispatch(getUserAllFormsDetails()).unwrap();
//     }

//     const handleDelete = async (_for, rem) => {
//         if(_for === "SoftSkills"){
//             const updatedData = [];
//             for (let i = 0; i < attribute[_for]?.length; i++) {
//                 if(i === rem) continue;
//                 updatedData.push(attribute[_for][i]);
//             }
//             console.log(updatedData, "===updatedData:handleDelete");
//             setAttribute(prev => ({ ...prev, "SoftSkills": updatedData }))
//             const res = await updateUserFormsDetails({ Data: updatedData, SK: "Skills#Soft" });
//             toastMessage("Successfully Deleted", "success");
//             dispatch(getUserAllFormsDetails()).unwrap();
//         }
//         else if(_for === "SpecialTalent"){
//             const updatedData = [];
//             for (let i = 0; i < attribute[_for]?.length; i++) {
//                 if(i === rem) continue;
//                 updatedData.push(attribute[_for][i]);
//             }
//             console.log(updatedData, "===updatedData:handleDelete");
//             setAttribute(prev => ({ ...prev, "SpecialTalent": updatedData }))
//             const res = await updateUserFormsDetails({ Data: updatedData, SK: "SpecialTalent#" });
//             toastMessage("Successfully Deleted", "success");
//             dispatch(getUserAllFormsDetails()).unwrap();
//         }
//         else if(_for === "PsychologicalChallenges"){
//             const updatedData = [];
//             for (let i = 0; i < attribute[_for]?.length; i++) {
//                 if(i === rem) continue;
//                 updatedData.push(attribute[_for][i]);
//             }
//             console.log(updatedData, "===updatedData:handleDelete");
//             setAttribute(prev => ({ ...prev, "PsychologicalChallenges": updatedData }))
//             const res = await updateUserFormsDetails({ Data: updatedData, SK: "Talent#Challenges#Psychological" });
//             toastMessage("Successfully Deleted", "success");
//             dispatch(getUserAllFormsDetails()).unwrap();
//         }
//         else if(_for === "SocialChallenges"){
//             const updatedData = [];
//             for (let i = 0; i < attribute[_for]?.length; i++) {
//                 if(i === rem) continue;
//                 updatedData.push(attribute[_for][i]);
//             }
//             console.log(updatedData, "===updatedData:handleDelete");
//             setAttribute(prev => ({ ...prev, "SocialChallenges": updatedData }))
//             const res = await updateUserFormsDetails({ Data: updatedData, SK: "Talent#Challenges#Social" });
//             toastMessage("Successfully Deleted", "success");
//             dispatch(getUserAllFormsDetails()).unwrap();
//         }
//         else if(_for === "ExtraCurricularActivities"){
//             const updatedData = [];
//             for (let i = 0; i < attribute[_for]?.length; i++) {
//                 if(i === rem) continue;
//                 updatedData.push(attribute[_for][i]);
//             }
//             console.log(updatedData, "===updatedData:handleDelete");
//             setAttribute(prev => ({ ...prev, "ExtraCurricularActivities": updatedData }))
//             const res = await updateUserFormsDetails({ Data: updatedData, SK: "Activity#ExtraCurricular" });
//             toastMessage("Successfully Deleted", "success");
//             dispatch(getUserAllFormsDetails()).unwrap();
//         }
//     }

//   const handleAddMoreClick = (_for) => {
//     return function () {
//       console.log(_for, " = Add_for");
//       setModal(_for);
//     };
//   };

//     return(
//       <div>
//           <PersonalityAttributesModal modal={modal} close={()=>setModal(null)} handleSave={handleSave} loading={loading} />
//           {personalAtt.map((data) => (
//               <EachAttributeData
//                   {...data}
//                   attribute={attribute}
//                   handleAddMoreClick={handleAddMoreClick}
//                   handleDelete={handleDelete}
//               />
//           ))}
//       {displayJsx}
//     </div>
//   );
// }

function EachAttributeData({
  id,
  name,
  _for,
  attribute,
  handleAddMoreClick,
  handleDelete,
}) {
  const [toggle, setToggle] = useState(false);
  const [docUrls, setDocUrls] = useState({});

  const getDocUrl = async (data, index) => {
    const res = await getS3Media(data);
    console.log("🚀 ~ getDocUrl ~ res:", res);
    setDocUrls((prev) => ({ ...prev, [index]: res?.data?.url }));
  };

  useEffect(() => {
    if (toggle && attribute[_for]?.length > 0) {
      attribute[_for].forEach((data, i) => {
        if (data?.Attachments?.length > 0 && !docUrls[i]) {
          getDocUrl(data?.Attachments[0], i);
        }
      });
    }
  }, [toggle, attribute, _for, docUrls]);

  let displayJsx = null;

  if (toggle && attribute[_for]?.length > 0) {
    displayJsx = attribute[_for]?.map((data, i) => {
      return (
        <div key={i} className="flex flex-col justify-center items-center">
          <div className="w-full my-3 p-1">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <p className="font-bold text-lg">{data.Name}</p>
              </div>
              <div
                className="flex gap-3 cursor-pointer"
                onClick={() => {
                  if (!btnDisableCond) {
                    handleDelete(_for, i);
                  }
                }}
              >
                <TrashIcon
                  className=""
                  color="#FF033E"
                  width="18"
                  height="18"
                />
              </div>
            </div>
            {data?.Language && (
              <div className="text-gray-500">{data?.Language}</div>
            )}
            {data && data["Website URL"] && (
              <div className="text-gray-500">{data["Website URL"]}</div>
            )}
            {data?.Description && (
              <div className="text-gray-500 overflow-scroll noScroll">
                {data?.Description}
              </div>
            )}
            {data?.Slide && (
              <div className="text-gray-500">
                {`level of ${data?.Name}: ${data?.Slide}`}
              </div>
            )}
            {data?.Attachments?.length > 0 && docUrls[i] && (
              <div className="text-gray-500">
                <a
                  href={docUrls[i]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary5"
                >
                  View Supporting Evidence
                </a>
              </div>
            )}
          </div>
          {attribute[_for]?.length === i + 1 ? (
            <></>
          ) : (
            <div className="h-[0.5px] bg-gray-200 w-full" />
          )}
        </div>
      );
    });
  } else if (!attribute[_for] || attribute[_for]?.length === 0) {
    displayJsx = (
      <p className="mt-3 text-center text-gray-500">
        Share your Personality Attributes with us!
      </p>
    );
  }

  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  const btnDisableCond =
    basicInfoData?.IsFinalSubmit && basicInfoData?.IsFinalSubmit;

  return (
    <div
      key={id}
      className="bg-pureWhite rounded-lg border-2 border-gray-100 shadow-md hover:shadow-lg p-4 mb-4"
    >
      <div className="w-full flex items-center gap-3">
        {attribute[_for]?.length > 0 && (
          <p className="cursor-pointer" onClick={() => setToggle(!toggle)}>
            {toggle ? <UpOutlined /> : <DownOutlined />}
          </p>
        )}
        <div className="w-full flex justify-between items-center">
          <div className="flex items-center gap-3">
            <p className="text-orange-gradient font-bold text-xl">{name}</p>
            <p className="text-[11px] border-[1px] border-gray-500 rounded-lg px-2">
              {attribute[_for]?.length} Items
            </p>
          </div>
          <Tooltip
            title={
              btnDisableCond
                ? "Once you click on the 'Final Submission' button, you won't be able to change your details."
                : ""
            }
          >
            <button
              disabled={btnDisableCond}
              onClick={handleAddMoreClick(_for)}
              className="text-orange-gradient text-orange-gradient-hover cursor-pointer font-bold text-sm"
            >
              Add
              <span className="ml-2 text-xl">+</span>
            </button>
          </Tooltip>
        </div>
      </div>
      {displayJsx}
    </div>
  );
}

export default PersonalityAttributes;
